// eslint-disable-next-line import/no-cycle
import wx from 'weixin-js-sdk';
// eslint-disable-next-line import/no-cycle
import { reqPostWeChatSignature } from '@/api/wechatServiceNum';
import { reqSchemeUrl } from '@/api/openMini';
import { getWechatAppId } from '@/utils/tools';
import store from '../store';

// 客户端下载二维码

const bodyHeight = document.documentElement.clientHeight || window.innerHeight;
const bodyWidth = document.documentElement.clientWidth || window.innerWidth;
const minHeight = bodyHeight - 400 - 65;
// 视频siteid
// eslint-disable-next-line import/no-mutable-exports
let RECORD_SITE_ID = '';
// eslint-disable-next-line import/no-mutable-exports
let LIVE_SITE_ID = '';
let HOST = 'https://dev.iqihang.com';
let ADMIN_URL = 'https://dev-api.iqihang.com';
const ENV = process.env.VUE_APP_ENV;
const ua = navigator.userAgent.toLowerCase();
const isOhos = /ohos/.test(ua);

switch (ENV) {
  case 'local':
    RECORD_SITE_ID = '161E6C10A6C93D4A';
    LIVE_SITE_ID = '1300EEA181B39F88';
    HOST = 'https://mobile-dev.iqihang.com';
    ADMIN_URL = 'https://mobile-test.iqihang.com/api/ark';
    break;
  case 'dev':
    RECORD_SITE_ID = '161E6C10A6C93D4A';
    LIVE_SITE_ID = '1300EEA181B39F88';
    HOST = 'https://mobile-dev.iqihang.com';
    ADMIN_URL = 'https://mobile-dev.iqihang.com/api/ark';
    break;
  case 'test':
    RECORD_SITE_ID = '161E6C10A6C93D4A';
    LIVE_SITE_ID = '1300EEA181B39F88';
    HOST = 'https://mobile-test.iqihang.com';
    ADMIN_URL = 'https://mobile-test.iqihang.com/api/ark';
    break;
  case 'release':
    RECORD_SITE_ID = '161E6C10A6C93D4A';
    LIVE_SITE_ID = '1300EEA181B39F88';
    HOST = 'https://mobile-release.iqihang.com';
    ADMIN_URL = 'https://api-release.iqihang.com';
    break;
  case 'pre':
    RECORD_SITE_ID = 'A183AC83A2983CCC';
    LIVE_SITE_ID = '5BBD2F25E0E3EF7D';
    HOST = 'https://mobile-pre.iqihang.com';
    ADMIN_URL = 'https://mobile-pre.iqihang.com/api/ark';
    break;
  default:
    RECORD_SITE_ID = 'A183AC83A2983CCC';
    LIVE_SITE_ID = '5BBD2F25E0E3EF7D';
    HOST = 'https://mobile.iqihang.com';
    ADMIN_URL = 'https://mobile.iqihang.com/api/ark';
}
// /api/ark
// 直播URL
const LIVE_URL = `${HOST}/ark/live/`;

/**
 * 判断是否登录
 */
// eslint-disable-next-line func-names
const isLogin = function () {
  if (store.state.userInfo.id && window.localStorage.getItem('accessToken')) {
    return true;
  }
  return false;
};

// 微信jssdk config注入
const wechatJSConfig = async () => {
  const wechatAppId = await getWechatAppId('pay');
  const res = await reqPostWeChatSignature({
    appId: wechatAppId,
    url: window.location.href.split('#')[0],
  });
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: res.data.appId, // 必填，公众号的唯一标识
    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature, // 必填，签名
    jsApiList: [
      'checkJsApi',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'scanQRCode',
      'chooseImage',
      'downloadImage',
    ], // 必填，需要使用的JS接口列表
  });
};

// 广告code码
const PC_CODE = 'pc0000';

const miniSchemeUrl= async(appid,path,query)=>{
  const params = {
    appid,
    path,
    envVersion: window.location.host.includes('mobile-test')||window.location.host.includes('mobile-pre') ? 'trial' : 'release',
  };
  if(query){
    params.query=query;
  }
  const {data} = await reqSchemeUrl(params);
  return data;
}

export {
  bodyHeight,
  bodyWidth,
  minHeight,
  RECORD_SITE_ID,
  LIVE_SITE_ID,
  LIVE_URL,
  isLogin,
  PC_CODE,
  wechatJSConfig,
  ADMIN_URL,
  HOST,
  miniSchemeUrl,
  isOhos,
  ENV
};
